import { runDemo } from "../shared/demoRunner";
import { createGltfMeshPrimitiveAttributeTestScene } from "./scene";

runDemo({
    createScene: createGltfMeshPrimitiveAttributeTestScene,
});
